<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{
        'LISTING_SYNC.LS_FREE_ADDON.GOOGLE_MY_BUSINESS.ACTIVATE_DIALOG.TITLE'
          | translate : { name: sourceName[sourceId] }
      }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="content">
      {{
        'LISTING_SYNC.LS_FREE_ADDON.GOOGLE_MY_BUSINESS.ACTIVATE_DIALOG.TEXT'
          | translate : { name: sourceName[sourceId], accountName: accountName }
      }}
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <div class="card-actions__primary">
      <button mat-stroked-button class="cancel-button button" [mat-dialog-close]="false">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" [mat-dialog-close]="true" data-action="activate-sync-CTA-modal">
        {{ 'COMMON.ACTIVATE_SYNC' | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
